import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../common/_services';
import { ThemeService } from '../../common/_theme/theme.service';
declare let Stripe: any;

@Component({
  selector: 'app-oauth-check',
  templateUrl: './oauthCheck.component.html',
  styleUrls: ['./oauthCheck.component.css'],
  standalone: false,
})
export class OAuthCheckComponent implements OnInit, OnDestroy {
  token = null;
  imgUrl = '';
  error = undefined;
  message = '';

  // Checks if user is already loggedIn
  storedTokens = null;
  private subscriptions: Subscription = new Subscription();
  stripe: any;
  apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private themeService: ThemeService,
    private http: HttpClient
  ) {
    this.imgUrl = this.themeService.getValueFromConfigurationThemeByKey('logoSpalshScreenUrl');
    this.token = this.route.snapshot.queryParams['token'];
    this.error = this.route.snapshot.queryParams['error'];
    this.message = this.route.snapshot.queryParams['message'];
    this.storedTokens = localStorage.getItem('auth_tokens');
  }

  async ngOnInit() {
    if (this.token && this.error === undefined) {
      // check if user is logged in and if it is we have to logout
      // Needed because of the way the oauth works, external providers may
      // want to change the user but the url for oauthCheck is always this one
      if (this.storedTokens) {
        await this.authenticationService.logout(false);
      }

      this.authenticationService.loginViaOauth(this.token).subscribe(() => {
        if (
          localStorage.getItem('goToStore') &&
          localStorage.getItem('goToStore').toString() == 'true'
        ) {
          setTimeout(() => {
            this.openStripeSession();
          }, 1000);
        } else {
          this.router.navigate(['/auth/redirect']);
        }
      });
    } else {
      swal.fire('Error' + this.error, this.message, 'warning');
    }
  }

  openStripeSession() {
    const linkId: string = localStorage.getItem('linkId');
    const planId: string = localStorage.getItem('planId');
    const planName: string = localStorage.getItem('planName');
    const promoCode: string = localStorage.getItem('promoCode');
    localStorage.removeItem('goToStore');
    localStorage.removeItem('planId');
    localStorage.removeItem('planName');
    localStorage.removeItem('promoCode');
    localStorage.removeItem('linkId');
    this.createStripeSession(planId, planName, promoCode, linkId);
  }

  createStripeSession(planId: string, planName: string, promoCode: string, linkId: string) {
    this.stripe = Stripe(environment.stripePublicApiKey);
    const paramMap = {
      linkId,
      planId,
      planName,
      promoCode,
      successCallback: this.apiBaseUrl + 'api/public/v1/store/stripe/checkoutSucceeded',
      cancelCallback: this.apiBaseUrl + 'api/public/v1/store/stripe/checkoutCanceled',
    };
    this.subscriptions.add(
      this.http
        .post<any>(`${this.apiBaseUrl}api/private/v1/store/stripe/createSession`, paramMap)
        .subscribe({
          next: (result: any) => {
            if (result.error) {
              console.error(result.error.message);
            } else {
              const sessionId = result?.id;
              if (sessionId) {
                this.stripe.redirectToCheckout({ sessionId }).catch((err) => {
                  console.error('Stripe redirection error:', err);
                });
              } else {
                console.error('Session ID not found in response');
              }
            }
          },
          error: (error: any) => {
            console.error('HTTP request error:', error);
          },
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
